var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"keypad-header"},[_c('button',{attrs:{"aria-label":"Go back"},on:{"click":_vm.goBack}},[_c('i',{staticClass:"fas fa-arrow-left"})]),_vm._t("header")],2),_c('div',{staticClass:"keypad-container center"},[_vm._t("container")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }